/**
 * Contains utility functions used to alter racks
 * in quick ways
 */

const values = Object.values;
const keys = Object.keys;
export const swap = (rack, fxA, fxB) => {
    let adj = rack.adjacencyLists;

    console.log('swap =', rack, fxA, fxB, allEdges(rack));

    // find all edges connected to A
    let edgesToA = allEdges(rack).filter(
        ({effect}) => effect === fxA);
    let fxToA = edgesToA.map(({fromNode}) => fromNode);
    
    // find all edges connected to B
    let edgesToB = allEdges(rack).filter(
        ({effect}) => effect === fxB);
    let fxToB = edgesToB.map(({fromNode}) => fromNode);

    let edgesFromB = adj[fxB.id];
    let fxFromB = adj[fxB.id].map(({effect}) => effect);

    let edgesFromA = adj[fxA.id];
    let fxFromA = adj[fxA.id].map(({effect}) => effect);

    // delete all these edges
    edgesToA.forEach(edge => rack.deleteEdge(edge));
    edgesToB.forEach(edge => rack.deleteEdge(edge));
    edgesFromB.forEach(edge => rack.deleteEdge(edge));
    edgesFromA.forEach(edge => rack.deleteEdge(edge));


    edgesToA
        .filter(x => x !== rack.inputNode)
        .forEach(({effect, fromNode}) => rack.connectNodes(effect, fromNode));
    edgesToB
        .filter(x => x !== rack.inputNode)
        .forEach(({effect, fromNode}) => rack.connectNodes(effect, fromNode));

    // connect the edges to swapped fx
    fxToA
        .filter(fx =>
                fx !== fxA &&
                fx !== fxB)
        .forEach(fx => rack.connectNodes(fx, fxB));
    fxToB
        .filter(fx =>
                fx !== fxB &&
                fx !== fxA)
        .forEach(fx => rack.connectNodes(fx, fxA));

    fxFromB.filter(
        fx =>
            !adj[fxA.id].some(e => e.effect === fx) &&
            fx !== fxB &&
            fx !== fxA)
        .forEach(fx => rack.connectNodes(fxA, fx));
    fxFromA
        .filter(
            fx =>
                !adj[fxB.id].some(e => e.effect === fx) &&
                fx !== fxA && 
                fx !== fxB)
        .forEach(fx => rack.connectNodes(fxB, fx));
};

const allEdges = (rack) => {
    return values(rack.adjacencyLists).flatMap(x => x);
};

export const getSelectedEffects = (elements, effects) => {
    let fx = keys(elements)
        .filter(id => elements[id])
        .map(id => effects.find(e => e.id === id))
        .filter(x => x && x.rack);
    let rack = undefined;
    if (fx[0]) {
        rack = fx[0].rack;
    }
    return {rack, effects: fx};
};
